export default __webpack_public_path__ + "static/media/avatar_9.0cef9c26.svg";